import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSpeaker: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSpeaker"><Path d="M4.5 2.5H19.5V21.5H4.5V2.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M16 14.5C16 16.7091 14.2091 18.5 12 18.5C9.79086 18.5 8 16.7091 8 14.5C8 12.2909 9.79086 10.5 12 10.5C14.2091 10.5 16 12.2909 16 14.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M9.5 6.5H14.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconSpeaker;
